module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-portfolio",
    attrs: {
      "ng-if": "data && data.length"
    }
  }, [_c('ul', {
    staticClass: "portfolio-list clearfix"
  }, _vm._l((_vm.paginate(_vm.data)), function(item) {
    return _c('li', {
      staticClass: "item",
      attrs: {
        "id": item.name
      }
    }, [_c('img', {
      staticClass: "item-img",
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-data"
    }, [_c('h4', {
      staticClass: "item-caption"
    }, [_vm._v(_vm._s(item.caption))]), _vm._v(" "), _c('div', {
      staticClass: "item-desc"
    }, [_vm._v(_vm._s(item.desc))]), _vm._v(" "), (item.link) ? _c('a', {
      staticClass: "item-desc",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.linkCaption || 'Open in new window') + " "), _c('span', {
      staticClass: "glyphicon glyphicon-new-window"
    })]) : _vm._e()])])
  })), _vm._v(" "), _c('nav', {
    attrs: {
      "aria-label": "Page navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', [_c('a', {
    attrs: {
      "aria-label": "Previous"
    },
    on: {
      "click": function($event) {
        _vm.setPage(_vm.currentPage - 1)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]), _vm._v(" "), _vm._l((_vm.totalPages), function(pageNumber) {
    return _c('li', [_c('a', {
      class: {
        current: _vm.currentPage === pageNumber - 1
      },
      on: {
        "click": function($event) {
          _vm.setPage(pageNumber - 1)
        }
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "aria-label": "Next"
    },
    on: {
      "click": function($event) {
        _vm.setPage(_vm.currentPage + 1)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bcacc19!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/viewPortfolio.vue
// module id = 51
// module chunks = 1